<h2>Tasks</h2>

<dx-data-grid
  class="dx-card content-block"
  [dataSource]="dataSource"
  [showBorders]="false"
  [focusedRowEnabled]="true"
  [focusedRowIndex]="0"
  [columnAutoWidth]="true"
  [columnHidingEnabled]="true">

  <dxo-data-grid-paging [pageSize]="10"></dxo-data-grid-paging>
  <dxo-data-grid-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-data-grid-pager>
  <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>

  <dxi-data-grid-column
    dataField="Task_ID"
    [width]="90"
    [hidingPriority]="2">
  </dxi-data-grid-column>
  
  <dxi-data-grid-column
    dataField="Task_Subject"
    [width]="190"
    caption="Subject"
    [hidingPriority]="8">
  </dxi-data-grid-column>
  <dxi-data-grid-column
    dataField="Task_Status"
    caption="Status"
    [hidingPriority]="6">
  </dxi-data-grid-column>
  <dxi-data-grid-column
    dataField="Task_Priority"
    caption="Priority"
    [hidingPriority]="5">
    <dxo-data-grid-lookup
      [dataSource]="priority"
      valueExpr="value"
      displayExpr="name">
    </dxo-data-grid-lookup>
  </dxi-data-grid-column>
  <dxi-data-grid-column
    dataField="ResponsibleEmployee.Employee_Full_Name"
    caption="Assigned To"
    [allowSorting]="false"
    [hidingPriority]="7">
  </dxi-data-grid-column>
  <dxi-data-grid-column
    dataField="Task_Start_Date"
    caption="Start Date"
    dataType="date"
    [hidingPriority]="3">
  </dxi-data-grid-column>
  <dxi-data-grid-column
    dataField="Task_Due_Date"
    caption="Due Date"
    dataType="date"
    [hidingPriority]="4">
  </dxi-data-grid-column>
  <dxi-data-grid-column
    dataField="Task_Priority"
    caption="Priority"
    name="Priority"
    [hidingPriority]="1">
  </dxi-data-grid-column>
  <dxi-data-grid-column
    dataField="Task_Completion"
    caption="Completion"
    [hidingPriority]="0">
  </dxi-data-grid-column>
</dx-data-grid>
